import { Modal, TextArea, Icon } from '@gerdau/hefesto';
import React from 'react';
import { Container, WarningMessage } from './styles';

interface ICancelOrderModalReason {
  onConfirm?: () => void;
  onCancel?: () => void;
  loading: boolean;
  message: string;
  setMessage: (newMessage: string) => void;
  showErrorMessage: boolean;
}
const CancelOrderModalReason: React.FC<ICancelOrderModalReason> = ({
  onConfirm,
  onCancel,
  loading,
  message,
  setMessage,
  showErrorMessage
}) => {
  return (
    <Modal
      title="Por favor, nos ajude a entender o motivo do cancelamento"
      buttons={{
        right: {
          disabled: loading,
          loading: loading,
          children: 'Enviar',
          name: 'confirm-button',
          onClick: onConfirm,
          type: 'button'
        }
      }}
      onClose={onCancel}
    >
      <Container>
        <TextArea
          label=""
          placeholder="Explique o motivo do cancelamento"
          name="Text area motivo do cancelamento"
          minLength={1}
          maxLength={50}
          disabled={loading}
          resizable={false}
          cols={76}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        {showErrorMessage ? null : (
          <div className="mandatory-msg">{`Obrigatório`}</div>
        )}
        {showErrorMessage ? (
          <WarningMessage>
            <Icon option="Alert" variant="danger" />
            Preencha o campo acima para dar continuidade a sua solicitação
          </WarningMessage>
        ) : null}
      </Container>
    </Modal>
  );
};

export default CancelOrderModalReason;
